module.exports = __webpack_public_path__ + "assets/img/doc_nfc_app_create_empty.c9dfb177.png";